import "react-phone-number-input/style.css";
import AdnCard from "../common/adnCard/AdnCard";
import React from "react";
import { Col, Row, Form } from "antd";
import AdnInput from "../common/adnInput/AdnInput";
import AdnAvatarUpload from "../common/adnAvatarUpload/AdnAvatarUpload";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import AdnEmail from "../common/adnEmail/AdnEmail";
import { AdnPhoneInput } from "../common/adnPhoneInput/AdnPhoneInput";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import { NameValidation, dateFormat } from "../common/GeneralConfigurations";
import { AdnValidationAdentisEmail } from "../login/LoginValidations";

function UserProfilePageForm({
  handleChangePasswordButton,
  visibleCP,
  handleSubmit,
  submitLoading,
  form,
  formPassword,
  handleSubmitPassword,
  submitPasswordLoading,
  loading,
  title,
  formHasErrors,
  saveImage,
  image,
  defaultPickerValue,
  disabledDate,
  handleBack,
  handleBlurName,
  samePasswords,
  matchingPasswords,
  imgLoading,
}) {
  return (
    <div>
      <AdnCard loading={loading}>
        <Row>
          <Col
            style={{ marginTop: "3%" }}
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 8 }}
            xxl={{ span: 8 }}
          >
            <AdnAvatarUpload
              saveImage={saveImage}
              imageUrl={image}
              loading={imgLoading}
            />
            {/*{!visibleCP && (*/}
            {/*    <>*/}
            {/*        <div style={{ textAlign: "center" }}>*/}
            {/*            {formHasErrors || (*/}
            {/*                <Button*/}
            {/*                    onClick={() => {*/}
            {/*                        handleChangePasswordButton(true);*/}
            {/*                    }}*/}
            {/*                    type={"link"}*/}
            {/*                >*/}
            {/*                    Change Password*/}
            {/*                </Button>*/}
            {/*            )}*/}
            {/*        </div>*/}
            {/*    </>*/}
            {/*)}*/}
            {/*<Form*/}
            {/*    layout="vertical"*/}
            {/*    form={formPassword}*/}
            {/*    onFinish={handleSubmitPassword}*/}
            {/*>*/}
            {/*    {visibleCP && (*/}
            {/*        <>*/}
            {/*            <Row>*/}
            {/*                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 16 }} xl={{ span: 20 }} xxl={{ span: 20 }}>*/}
            {/*                    <AdnInput*/}
            {/*                        prefix={*/}
            {/*                            <LockOutlined className="site-form-item-icon" />*/}
            {/*                        }*/}
            {/*                        type="password"*/}
            {/*                        label="Old Password"*/}
            {/*                        placeholder="Insert Old Password"*/}
            {/*                        name="oldPassword"*/}
            {/*                        maxLength={50}*/}
            {/*                        validateTrigger="onSubmit"*/}
            {/*                        rules={[*/}
            {/*                            {*/}
            {/*                                required: true,*/}
            {/*                                message: "Old Password is required",*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                pattern: passwordRegex,*/}
            {/*                                message:*/}
            {/*                                    "At least 8 characters, one lowercase, one uppercase letters, one number and one special character",*/}
            {/*                            },*/}
            {/*                        ]}*/}
            {/*                    />*/}
            {/*                    <AdnInput*/}
            {/*                        prefix={*/}
            {/*                            <LockOutlined className="site-form-item-icon" />*/}
            {/*                        }*/}
            {/*                        type="password"*/}
            {/*                        label="New Password"*/}
            {/*                        placeholder="Insert New Password"*/}
            {/*                        name="newPassword"*/}
            {/*                        maxLength={50}*/}
            {/*                        validateTrigger="onSubmit"*/}
            {/*                        rules={[*/}
            {/*                            {*/}
            {/*                                required: true,*/}
            {/*                                message: "New Password is required",*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                pattern: passwordRegex,*/}
            {/*                                message:*/}
            {/*                                    "At least 8 characters, one lowercase, one uppercase letters, one number and one special character",*/}
            {/*                            },*/}
            {/*                            ({ getFieldValue }) => ({*/}
            {/*                                validator(_, value) {*/}
            {/*                                    if (*/}
            {/*                                        !value ||*/}
            {/*                                        !passwordRegex.test(value) ||*/}
            {/*                                        getFieldValue("oldPassword") !== value*/}
            {/*                                    ) {*/}
            {/*                                        return Promise.resolve();*/}
            {/*                                    }*/}
            {/*                                    return Promise.reject(new Error(samePasswords));*/}
            {/*                                },*/}
            {/*                            }),*/}
            {/*                        ]}*/}
            {/*                    />*/}
            {/*                    <AdnInput*/}
            {/*                        prefix={*/}
            {/*                            <LockOutlined className="site-form-item-icon" />*/}
            {/*                        }*/}
            {/*                        type="password"*/}
            {/*                        label="Confirm New Password"*/}
            {/*                        placeholder="Confirm New Password"*/}
            {/*                        name="confirmPassword"*/}
            {/*                        maxLength={50}*/}
            {/*                        validateTrigger="onSubmit"*/}
            {/*                        rules={[*/}
            {/*                            {*/}
            {/*                                required: true,*/}
            {/*                                message: "Confirmation Password is required",*/}
            {/*                            },*/}
            {/*                            ({ getFieldValue }) => ({*/}
            {/*                                validator(_, value) {*/}
            {/*                                    if (*/}
            {/*                                        !value ||*/}
            {/*                                        !getFieldValue("newPassword") ||*/}
            {/*                                        getFieldValue("newPassword") === value*/}
            {/*                                    ) {*/}
            {/*                                        return Promise.resolve();*/}
            {/*                                    }*/}
            {/*                                    return Promise.reject(*/}
            {/*                                        new Error(matchingPasswords)*/}
            {/*                                    );*/}
            {/*                                },*/}
            {/*                            }),*/}
            {/*                        ]}*/}
            {/*                    />*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <div style={{ textAlign: "center" }}>*/}
            {/*                <Space>*/}
            {/*                    <Button*/}
            {/*                        onClick={() => {*/}
            {/*                            handleChangePasswordButton(false);*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        Close*/}
            {/*                    </Button>*/}
            {/*                    <AdnSaveButton loading={submitPasswordLoading} />*/}
            {/*                </Space>*/}
            {/*            </div>*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*</Form>*/}
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 20 }}
            xl={{ span: 16 }}
            xxl={{ span: 16 }}
          >
            <Form layout="vertical" form={form} onFinish={handleSubmit}>
              <Row gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 8 }}
                  xxl={{ span: 8 }}
                >
                  <AdnInput
                    label={"Name"}
                    placeholder={"Insert Name"}
                    name={"name"}
                    rules={NameValidation}
                    maxLength={50}
                    handleBlur={handleBlurName}
                    readOnly={visibleCP}
                    disabled="true"
                  />
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 8 }}
                  xxl={{ span: 8 }}
                >
                  <AdnDatePicker
                    label="Birth Date"
                    name="birthDate"
                    placeholder={"Select Date"}
                    disabledDate={disabledDate}
                    defaultPickerValue={defaultPickerValue}
                    disabled={visibleCP}
                    format={dateFormat}
                    disabled="true"
                  />
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 8 }}
                  xxl={{ span: 8 }}
                >
                  <AdnInput
                    name={"role"}
                    label={"Role"}
                    readOnly={true}
                    disabled="true"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnEmail
                    readOnly={true}
                    validationType={AdnValidationAdentisEmail}
                    disabled="true"
                  />
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnPhoneInput
                    name="phone"
                    disabled={visibleCP}
                    disabled="true"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnInput
                    name={"department"}
                    label={"Department"}
                    readOnly={true}
                    disabled="true"
                  />
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 20 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnInput
                    name={"workPlace"}
                    label={"Location"}
                    readOnly={true}
                    disabled="true"
                  />
                </Col>
                {form.getFieldValue("seniorManager") ? (
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 20 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                  >
                    <AdnInput
                      name={"seniorManager"}
                      label={"Senior Manager"}
                      readOnly={true}
                      disabled="true"
                    />
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
              {visibleCP || (
                <AdnFormOptions
                  handleCancel={handleBack}
                  readOnly={true}
                  //loading={submitLoading}
                />
              )}
            </Form>
          </Col>
        </Row>
      </AdnCard>
    </div>
  );
}

export default UserProfilePageForm;
